import React from "react";

import VitalSignsHistory from "./VitalSignsHistory";

import { Card } from "antd";

export default function VitalSigns({ id, sex, patientDetails }) {
  return (
    <Card className="card-with-table">
      <VitalSignsHistory id={id} sex={sex} patientDetails={patientDetails} />
    </Card>
  );
}
